export const ErrorMappings = [
  {
    code: 400,
    title: 'ErrorPage400Title',
    body: 'ErrorPage400Body',
    buttonText: '',
  },
  {
    code: 401,
    title: 'ErrorPage401Title',
    body: 'ErrorPage401Body',
    buttonText: 'SignIn',
  },
  {
    code: 403,
    title: 'ErrorPage403Title',
    body: 'ErrorPage403Body',
    buttonText: '',
  },
  {
    code: 404,
    title: 'ErrorPage404Title',
    body: 'ErrorPage404Body',
  },
  {
    code: 500,
    title: 'ErrorPage500Title',
    body: 'ErrorPage500Body',
    buttonText: 'refreshPage',
  },
  {
    code: 502,
    title: 'ErrorPage502Title',
    body: 'ErrorPage502Body',
    buttonText: 'refreshPage',
  },
  {
    code: 503,
    title: 'ErrorPage503Title',
    body: 'ErrorPage503Body',
    buttonText: '',
  },
  {
    code: 504,
    title: 'ErrorPage504Title',
    body: 'ErrorPage504Body',
    buttonText: 'refreshPage',
  },
  {
    code: '',
    title: 'ErrorPagePermissionConflictTitle',
    body: 'ErrorPagePermissionConflictBody',
    buttonText: '',
  },
];
